import { initialStateGlobalSettings } from './state';
import SecureLS from 'secure-ls'
import jwt_decode from 'jwt-decode'
import axios from 'axios'


let mutations = {
    updateLoggingIn(state,payload){
        /***
         * Mutación de inicio de sesión, en esta se reciben los datos del usuario y se crean en la store
         * se recibe el token y se almacena cifrado y adicional se asigna la bandera true para saber
         * que se encuentra loggueado, este también se almacena cifrado
         */
        state.user.fullName = payload.user.name+' '+payload.user.surname;
        state.user.email = payload.user.email;
        state.idleTime = payload.idleTime*1000;
        var permissions_array = [];
        for(var i=0;i<payload.user.group.permissions.edges.length;i++)
        {
            permissions_array.push(
                payload.user.group.permissions.edges[i].node.codename
            )
        }
        var decoded = jwt_decode(payload.token);
        axios.defaults.headers.common["Authorization"] = `Jwt ${payload.token}`;
        var permissions = new SecureLS({encodingType: 'aes'});
        permissions.set('permissions', {data: permissions_array});
        var adminLoggingIn = new SecureLS({encodingType: 'aes'});
        adminLoggingIn.set('adminLoggingIn', {data: true});
        var adminAccessToken = new SecureLS({encodingType: 'aes'});
        adminAccessToken.set('adminAccessToken', {data: payload.token});
        var adminRefreshToken = new SecureLS({encodingType: 'aes'});
        adminRefreshToken.set('adminRefreshToken', {data: payload.refreshToken});
        var adminTokenExpireDate = new SecureLS({encodingType: 'aes'});
        adminTokenExpireDate.set('adminTokenExpireDate', {data: decoded.exp});
    },
    logout(state,payload) {
        /***
         * Mutación para cierre de sesión, se reinicia el estado de la store y se elimina la bandera de 
         * logueado y el token almacenado
         */
        axios.defaults.headers.common["Authorization"] = '';
        var adminLoggingIn = new SecureLS({encodingType: 'aes'});
        adminLoggingIn.remove('adminLoggingIn');
        var adminAccessToken = new SecureLS({encodingType: 'aes'});
        adminAccessToken.remove('adminAccessToken');
        var adminRefreshToken = new SecureLS({encodingType: 'aes'});
        adminRefreshToken.remove('adminRefreshToken');
        var adminTokenExpireDate = new SecureLS({encodingType: 'aes'});
        adminTokenExpireDate.remove('adminTokenExpireDate');
        var permissions = new SecureLS({encodingType: 'aes'});
        permissions.remove('permissions');
        const initial = initialStateGlobalSettings()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    resetState(state,payload) {
        const initial = initialStateGlobalSettings()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    idleSet(state,payload) {
        state.idleTime = 15000;
    },
    setResetUser(state,payload){
        /***
         * Mutación para almacenar en la store (no localstorage) los datos del usuario
         * que solicita reseteo de contraseña, se almacena el Id del usuario
         * y el token de reset que envía el servidor
         */
        state.resetToken = payload.resetToken;
        state.resetUserId = payload.resetUserId;
    },
    updateToken(state, payload){
        /***
        * Mutación para refrescar el token
        */
        var decoded = jwt_decode(payload.token);
        axios.defaults.headers.common["Authorization"] = `Jwt ${payload.token}`;
        var adminAccessToken = new SecureLS({encodingType: 'aes'});
        adminAccessToken.set('adminAccessToken', {data: payload.token});
        var adminTokenExpireDate = new SecureLS({encodingType: 'aes'});
        adminTokenExpireDate.set('adminTokenExpireDate', {data: decoded.exp});
    },
    setLogoutState(state,status){
        /***
         * Mutación para setear estado falso o verdadero al cierre de sesión
         */
        state.logoutState = status;
    }

}
export default mutations
